import * as React from 'react';
import { Select } from 'antd';
import { IMallPharmacyDetail } from '../../entity/MallEntity';
import I18N from 'src/services/I18NService';
import uuid from 'uuid';

const { OptGroup } = Select;

interface ISupplierPharmacySelectProps {
  className?: string;
  style?: React.CSSProperties;
  /** 是否显示选项“无” */
  showNone: boolean;
  /** 所有单元药库的列表 */
  pharmacyList: IMallPharmacyDetail[];
  /** 受控属性 value */
  value?: string;
  /** 下拉框数据改变时回调 */
  onChange: (value: string | null | undefined) => void;
}

interface ISupplierPharmacySelectState {}

/**
 * 供应商单元药库下拉选择组件
 *
 * @author kai.chen
 * @date 2020-08-05
 * @class SupplierPharmacySelect
 */
class SupplierPharmacySelect extends React.Component<ISupplierPharmacySelectProps, ISupplierPharmacySelectState> {
  constructor(props: ISupplierPharmacySelectProps) {
    super(props);
  }



  /**
   * 下拉项分组
   *
   */
  getOptionGroup = (): JSX.Element[] => {
    const result: JSX.Element[] = [];
    const { pharmacyList } = this.props;

    const sellerPharmacyMap = new Map<string, IMallPharmacyDetail[]>();
    for (const pharmacyObj of pharmacyList.filter((t) => !t.is_deleted)) {
      if (!!pharmacyObj && !!pharmacyObj.seller_user_name) {
        const sellerName = pharmacyObj.seller_user_name;
        if (sellerPharmacyMap.has(sellerName)) {
          const tempData = sellerPharmacyMap.get(sellerName) || [];
          tempData.push(pharmacyObj);
        } else {
          sellerPharmacyMap.set(sellerName, [pharmacyObj]);
        }
      }
    }

    sellerPharmacyMap.forEach((list, supplier) => {
      result.push(
        <OptGroup key={uuid.v4()} label={supplier}>
          {list.map((f) => {
            return (
              <Select.Option key={`${f.uuid}_${f.name}`} value={f.uuid}>
                {f.is_active ? f.name : `${f.name}(${I18N.get('common_status_disable')})`}
              </Select.Option>
            );
          })}
        </OptGroup>
      );
    });

    return result;
  };

  /**
   * 下拉数据变更触发
   *
   */
  pharmacyChange = (value: string | null | undefined) => {
    this.props.onChange(value);
  };

  render() {
    const { showNone, className, style, value } = this.props;
    return (
      <Select
        className={className}
        style={style}
        dropdownMatchSelectWidth={false}
        allowClear={true}
        value={value}
        onChange={this.pharmacyChange}
        placeholder={`${I18N.get('common_choose')}${I18N.get('unit_pharmacy')}`}
      >
        {showNone && (
          <Select.Option key={'null'} value={'null'}>
            {I18N.get('common_none')}
          </Select.Option>
        )}
        {this.getOptionGroup()}
      </Select>
    );
  }
}

export default SupplierPharmacySelect;



// WEBPACK FOOTER //
// ./src/components/common/SupplierPharmacySelect.tsx